<template>
  <div id="app" class="app-box">

    <keep-alive v-if="$route.meta && $route.meta.keepAlive">
      <router-view v-if="isRouterAlive"></router-view>
    </keep-alive>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import eventBus from './event-bus.js'; // 引入事件总线
export default {
  // 点击页面侧边栏重载功能的实现（该处提供了提供给后代组件的数据/方法）
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  methods: {
    //页面重新载入函数
    reload () {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  },
  mounted () {
    let ua = navigator.userAgent.toLocaleLowerCase()
    console.log(ua, 'uas')
    let list = ua.split(' ');
    let appId = ''
    for (let i = 0; i < list.length; i++) {
      if (list[i].match(/appid/) || list[i].match(/appId/)) {
        appId = list[i].slice(6)
      }
    }

    if (appId != '') {

      sessionStorage.setItem('appId', appId)
      localStorage.setItem('appId', appId)
    }

  },
  methods: {
    nativeCallJsSchemeUserAuth (val) {
      // 设置认证完成状态
      // vocationalVal.isAuthComplete = true;
      localStorage.setItem('appToken', val)
      sessionStorage.setItem('appToken', val)
    },
  },
  components: {

  }
}

</script>

<style>
.van-toast {
  z-index: 10001 !important;
}
#app {
  --global-theme-color: #4086f6;
  --global-color-a: #121924;
  --global-color-b: #202020;
  --global-color-c: #666666;
  --global-color-d: #999999;
  --global-color-e: #bfbfbf;
}
/*body {
		width: 100%;
		height: 100%;
		overflow: hidden;
	}*/
.el-tooltip__popper {
  background: rgba(0, 0, 0, 0.7);
  color: #fff;
  font-size: 15px !important;
  padding: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
}
.app-box {
  /* width: 100%;
  min-width: 1300px;

  position: relative;
  min-height: 100vh;
  height: 100%;
  background: #fff;
  font-size: 14px;
  font-family: Avenir, Helvetica, Arial, sans-serif; */
}

/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background-color: transparent;
  z-index: 1000;
}

/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  /*-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);*/
  border-radius: 10px;
  background-color: transparent;
  z-index: 1000;
}

/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: transparent;
  z-index: 1000;
}
.pointer {
  cursor: pointer;
}
/* 头部 侧边通用样式 */
.wrapper {
  width: 100%;
  display: flex;
  /* position: relative; */
}

.catalogue {
  /* width: 240px; */
  margin-left: 20px;
  min-width: 240px;
  height: 810px;
  background: #ffffff;
  box-shadow: 0px 2px 16px 0px rgba(153, 153, 153, 0.16);
  border-radius: 10px;
  /* position: absolute;
		top: 0;
		left: 0; */
  padding: 20px;
  box-sizing: border-box;
}
.catalogue .tree {
  width: 100%;
  display: block;
  /* margin-top: 20px; */
}

.title {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.title p {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #202020;
}
/* .title button{
	  width: 60px;
	  height: 32px;
	   padding: 0 !important;
	  border-radius: 4px;
  } */
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  background: #fff;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgb(0 0 0 / 30%);
  box-shadow: 0 1px 3pxrgba (0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 50%;
  border-radius: 10px;
}
#dataDictionary .el-dialog__body {
  padding: 30px 20px;
  color: #606266;
  font-size: 14px;
  word-break: break-all;
  padding-top: 0 !important;
}
.compile_form .el-form-item__label {
  padding: 0 !important;
}

.el-upload--picture-card {
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100px !important;
  height: 100px !important;

  cursor: pointer;
  line-height: 100px !important;
  vertical-align: top;
}
.el-upload-list--picture-card .el-upload-list__item {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100px !important;
  height: 100px !important;
  margin: 0 8px 8px 0;
  display: inline-block;
}
</style>
<style lang="less">
#addResource,
#dataDictionary,
#freeAppRegister,
#standardList,
#interfaceAuth {
  .contont_main {
    width: calc(100% - 260px) !important;
  }
  .contont_wrapper {
    width: calc(100% - 40px) !important;
    overflow-y: scroll;
  }
}
/deep/.el-input__inner {
  &::placeholder {
    color: red;
    font-size: 16px;
  }
}
</style>
